import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
const RecentWorks = () => {
  const works = [
    {
      id: 1,
      title: "Voice Broadcasting",
      image: "./assets/images/recentWork/voip.png",
    },
    {
      id: 2,
      title: "Translytor App",
      image: "./assets/images/recentWork/transly.jpg",
    },
    {
      id: 3,
      title: "WDT Energy",
      image: "./assets/images/recentWork/wdtenergy.png",
    },
    {
      id: 4,
      title: "OTT Platform",
      image: "./assets/images/recentWork/ott1.png",
    },
    {
      id: 5,
      title: "bousouglobal",
      image: "./assets/images/recentWork/bousouglobal.png",
    },
    {
      id: 6,
      title: "Blue pay Card",
      image: "./assets/images/recentWork/blupay.jpg",
    },
    {
      id: 7,
      title: "Jean Gilles Capital",
      image: "./assets/images/recentWork/jeangilles.jpg",
    },
    {
      id: 8,
      title: "Jewelivery",
      image: "./assets/images/recentWork/jewe.png",
    },
  ];

  const WorkCard = ({ work }) => {
    return (
      <div className="flex flex-col items-center ">
        {/* Card */}
        <div
          className=" rounded-lg shadow-lg group relative w-70 h-80 overflow-hidden"
          style={{
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
          }}
        >
          <div className="relative h-full group-hover:h-auto transition-all duration-2000">
            <img
              src={work.image}
              alt={work.title}
              className="w-full h-auto object-cover group-hover:animate-scroll"
            />
          </div>
        </div>
        {/* Title Below the Card */}
        <h3 className="text-lg font-semibold text-gray-800 mt-4 text-center">
          {work.title}
        </h3>
      </div>
    );
  };

  return (
    <div className=" p-6 ">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 text-gray-800">
            Our Recent Works
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover some of our latest projects where creativity meets
            technology. Explore the details and see how we bring ideas to life.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {works.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <a
          href="/portfolio/portfolio.html"
          className="flex items-center gap-x-1 text-l font-bold l"
        >
          <button className="flex items-center px-6 py-3 text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-all duration-300">
            <FontAwesomeIcon icon={faBriefcase} className="mr-2" />
            View Portfolio
          </button>
        </a>
      </div>
    </div>
  );
};

export default RecentWorks;
